import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Film, Scissors, Image, Music, FileText, Camera } from "lucide-react";

const items = [
  { icon: Film, title: "Episodio completo editado", body: "Multicámara, corregido de color y con ritmo. Listo para YouTube y tu web." },
  { icon: Scissors, title: "Clips verticales", body: "Cortes optimizados para Reels, Shorts y TikTok, con subtítulos quemados." },
  { icon: Image, title: "Miniaturas y portadas", body: "Diseñadas con la línea gráfica que uses para ese cliente." },
  { icon: Music, title: "Audio para plataformas", body: "Máster de audio limpio para Spotify, Apple Podcasts y iVoox." },
  { icon: FileText, title: "Guion y escaleta", body: "Preguntas y estructura preparadas antes de grabar. Nadie improvisa." },
  { icon: Camera, title: "Fotos del set", body: "Fotografías de la grabación para que tu cliente alimente sus perfiles." },
];

export default function AgenciesDeliverables() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="entregables"
      className="section-spacing bg-white"
      data-testid="agencies-deliverables"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mb-14"
        >
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-galvani-purple font-body font-semibold mb-4">
            Qué entregamos
          </span>
          <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-galvani-text mb-5">
            De una jornada de grabación sale{" "}
            <span className="gradient-text">todo el contenido del mes</span>
          </h2>
          <p className="font-body text-base text-galvani-textLight leading-relaxed">
            Esto es lo que recibes por cada grabación, con tu marca y en el formato que necesites
            para entregárselo a tu cliente.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 24 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.08 * i }}
              className="flex items-start gap-4 p-6 rounded-2xl bg-galvani-bg border border-slate-200"
              data-testid={`agencies-deliverable-${i + 1}`}
            >
              <div className="w-11 h-11 rounded-xl bg-white border border-slate-200 flex items-center justify-center flex-shrink-0">
                <item.icon className="w-5 h-5 text-galvani-purple" />
              </div>
              <div>
                <h3 className="font-heading font-semibold text-base text-galvani-text mb-1">
                  {item.title}
                </h3>
                <p className="font-body text-sm text-galvani-textLight leading-relaxed">
                  {item.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
